
import {
  defineComponent, watch, reactive, onMounted,
} from 'vue';
import { ICenarioFiscalDefinicao, ICenarioFiscalDefinicaoIbsCbs } from '@/models/Entidades/Cadastros/Tributacoes/CenariosFiscais/ICenarioFiscal';
import SelecionarCstIbs from '@/components/Cadastros/Tributacoes/IbsCbs/SelecionarCstIbs.vue';
import SelecionarClassificacaoIbs from '@/components/Cadastros/Tributacoes/IbsCbs/SelecionarClassificacaoIbs.vue';
import { ICstIbsCbs } from '@/models/Entidades/Cadastros/Tributacoes/CenariosFiscais/IbsCbs/ICstIbsCbs';
import { IClassificacaoIbsCbs } from '@/models/Entidades/Cadastros/Tributacoes/CenariosFiscais/IbsCbs/IClassificacaoIbsCbs';
import ServicoIbsCbs from '@/servicos/Cadastros/Tributacoes/ServicoIbsCbs';

interface IFormIbsCbs {
  cst: ICstIbsCbs | null;
  classificacao: IClassificacaoIbsCbs | null;
}

export default defineComponent({
  name: 'CenarioFiscalDefinicaoIbsCbs',
  components: {
    SelecionarCstIbs,
    SelecionarClassificacaoIbs,
  },
  props: {
    definicao: {
      type: Object as () => ICenarioFiscalDefinicao,
      required: true,
    },
  },
  setup(props, { emit }) {
    const form = reactive<IFormIbsCbs>({
      cst: null,
      classificacao: null,
    });

    let todosOsCsts: ICstIbsCbs[] = [];
    let todasAsClassificacoes: IClassificacaoIbsCbs[] = [];

    function preencherFormularioComDadosDaProp(valorProp: ICenarioFiscalDefinicao) {
      if (valorProp && valorProp.definicaoIbsCbs) {
        const { codigoIbsCbs, codigoClassificacao } = valorProp.definicaoIbsCbs;
        form.cst = todosOsCsts.find((c) => c.codigo === codigoIbsCbs) || null;
        form.classificacao = todasAsClassificacoes.find((c) => c.codigo === codigoClassificacao) || null;
      } else {
        form.cst = null;
        form.classificacao = null;
      }
    }

    onMounted(async () => {
      [todosOsCsts, todasAsClassificacoes] = await Promise.all([
        ServicoIbsCbs.obterIbsCbs(),
        ServicoIbsCbs.obterIClassificacaoIbsCbs(),
      ]);
      // Dispara a verificação inicial após carregar os dados
      preencherFormularioComDadosDaProp(props.definicao);
    });

    watch(
      () => form.cst,
      (novoCst) => {
        if (!novoCst) {
          form.classificacao = null;

          const updatedDefinicao = { ...props.definicao };

          updatedDefinicao.definicaoIbsCbs = {
            codigoIbsCbs: 0,
            codigoClassificacao: 0,
          } as ICenarioFiscalDefinicaoIbsCbs;

          emit('update:definicao', updatedDefinicao);
        }
      },
    );

    watch(() => form, (newValue) => {
      const updatedDefinicao = { ...props.definicao };
      if (!updatedDefinicao.definicaoIbsCbs) {
        updatedDefinicao.definicaoIbsCbs = {} as ICenarioFiscalDefinicaoIbsCbs;
      }
      updatedDefinicao.definicaoIbsCbs.codigoIbsCbs = newValue.cst?.codigo || 0;
      updatedDefinicao.definicaoIbsCbs.codigoClassificacao = newValue.classificacao?.codigo || 0;
      emit('update:definicao', updatedDefinicao);
    }, { deep: true });

    watch(() => props.definicao, (newValue) => {
      preencherFormularioComDadosDaProp(newValue);
    }, { deep: true });

    return {
      form,
    };
  },
});
